import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { registerQuery, useQuery } from 'data-fetching-client';
import { api } from '../utils/api';
import { THREAD_ATTACHMENTS_BASE_PATH } from '../../api/paths';
import { getIsPreview } from '../utils/isPreview';
export const GET_THREAD_ATTACHMENTS_KEY = 'getThreadAttachments';
export const fetchThreadAttachments = async variables => {
  const {
    isPreview
  } = getIsPreview();
  if (isPreview) {
    return {
      attachmentsList: [],
      sensitiveAttachmentsList: []
    };
  }
  const {
    ticketId,
    threadId
  } = variables;
  const response = await api(`${THREAD_ATTACHMENTS_BASE_PATH}/${ticketId}/${threadId}`);
  const data = await response.json();
  return data;
};
export const GET_THREAD_ATTACHMENTS = registerQuery({
  fieldName: GET_THREAD_ATTACHMENTS_KEY,
  args: ['ticketId', 'threadId'],
  fetcher: fetchThreadAttachments
});
export const useThreadAttachments = (ticketId, threadId) => {
  const _useQuery = useQuery(GET_THREAD_ATTACHMENTS, {
      variables: {
        ticketId,
        threadId
      },
      skip: !ticketId || !threadId
    }),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data[GET_THREAD_ATTACHMENTS_KEY],
    loading,
    refetch
  }, rest);
};